import { render, staticRenderFns } from "./Que3.vue?vue&type=template&id=48106003&scoped=true&"
import script from "./Que3.vue?vue&type=script&lang=js&"
export * from "./Que3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48106003",
  null
  
)

export default component.exports